import AbstractPageBaseController from '../../../../../modules/core/abstracts/controllers/page-controller';

export default class GuestlistsListPageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.store = this.stateParams.store || this.injector.get('Guestlists');
        this.store.commit('setEmptyListActions', [
            'create-guestlist'
        ]);
        this.store.commit('setVm', this);
        this.store.dispatch('loadWorkflows', 'guestlists::list');
        this.store.resetGetters();

        this._initCurrentView();
    }

    goToGridView() {
        this.state.current.data.collapsedSidebarOnLoad = true;
        this.changeView('grid');
    }

    changeView(newView) {
        this.currentView = newView;
        localStorage.setItem('AlGuestlistsListViewType', newView);
    }

    _initCurrentView() {
        this.currentView = 'list';

        const localStorageView = localStorage.getItem('AlGuestlistsListViewType');
        if (
            localStorageView
            && (
                localStorageView === 'list'
                || localStorageView === 'grid'
            )
        ) {
            this.currentView = localStorageView;
        }

        this.state.current.data.collapsedSidebarOnLoad = (this.currentView === 'grid');
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/list-controller.js